<template>
  <div class="exchangeBaseInfo">
    <div v-loading="loading" class="rj-page-card">
      <div class="rj-page-card__title">
        退货合同
      </div>
      <div class="rj-page-card__content">
        <el-form ref="form" :model="info" :rules="rules" class="baseInfoForm">
          <div class="rj-row">
            <div class="rj-col-66">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  项目名称：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.rprojectName }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  订单日期：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.rcreatedTime }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  电子商务合同编号：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.rnewContractNum }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  原订单合同编号：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.roldContractNum }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  订单分类：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.rorderType }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  退换货原因：
                </div>
                <div class="rj-baseinfo__item">
                  {{ displayReasonType(info.rreasonType) }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  场景分类：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.rScenarioCategory }}
                </div>
              </div>
            </div>
            <div class="rj-col-1">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  供货单位(甲方)：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.supplyUnit }}
                </div>
              </div>
            </div>
            <div class="rj-col-66">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  供货单位地址：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.supplyAddress }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  供货单位电话(甲方)：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.supplyPhone }}
                </div>
              </div>
            </div>
            <div class="rj-col-66">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  订货单位(乙方)：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.rorderUnitName }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  订货单位电话(乙方)：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.rorderUnitTel }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  最终客户：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.rfinalCustomerName }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  客户签约类型：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.rdistributorName }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  区域：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.rsalesArea }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  首级集成商名称：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.rintegratorName }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  首级集成商类型：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.rintegratorSignType }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  区域商务专员：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.rassistantName }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  售前名称：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.rpreSalesPersonName }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  外销名称：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.rsalesPersonName }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  部门：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.rsalesPersonDeptName }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  末级集成商名称：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.finalIntegratorsName }}
                </div>
              </div>
            </div>
            <div class="rj-col-66">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  末级集成商类型：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.finalIntegratorsType }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  计量集成商名称：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.metrologyIntegratorName }}
                </div>
              </div>
            </div>
            <div class="rj-col-66">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  计量集成商类型：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.metrologyIntegratorType }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  细分市场：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.rmarketSegmentName }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  应用场合：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.rapplicationScenariosName }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  应用场景：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.rapplicationSceneName }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  退票方式：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.rrefundInvoiceTypeName }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  物流公司：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.rlogisticsCompanyName }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  物流单号：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.rlogisticsNum }}
                </div>
              </div>
            </div>
            <div class="rj-col-66">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  退票收件地址：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.rreceivingAddress }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  红字发票信息编号：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.rinvoiceRedNum || '' }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  返利退还金额：
                </div>
                <div class="rj-baseinfo__item">
                  {{ info.rrefundRebate }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  净销售额：
                </div>
                <div class="rj-baseinfo__item">
                  -{{ info.rnetSales }}
                </div>
              </div>
            </div>

            <div class="rj-col-1">
              <el-form-item prop="rsupplementalTerm" label="补充条款:">
                <el-input v-model.trim="info.rsupplementalTerm" type="textarea" :rows="3" placeholder="请输入补充条款内容" />
              </el-form-item>
            </div>
            <div class="rj-col-1">
              <el-form-item prop="remarks" label="备注说明:">
                <el-input v-model.trim="info.rremarks" type="textarea" :rows="3" placeholder="请输入备注说明" />
              </el-form-item>
            </div>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { displayReasonType } from '@/constant';
export default {
  data () {
    return {
      loading: false,
      form: {},
      rules: {}
    };
  },
  props: {
    info: {
      type: Object,
      default: () => { return {}; }
    }
  },
  methods: {
    /**
     * 退换货原因展示名（D8）：落库值保持不变，仅展示层映射。
     *
     * @param {string} reasonType 后端返回的落库原因值
     * @returns {string} 展示文案
     */
    displayReasonType
  }
};
</script>

<style lang='scss'>
.exchangeBaseInfo{
 .rj-col-66 {
    float: left;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    width: 66.6666%;
}
.rj-col-66 {
    float: left;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    width: 66.6666%;
}
}

</style>
